export default {"icons":{"iconfont":"fa"},"theme":{"themes":{"light":{"primary":"#ffa142","secondary":"#65cda2","accent":"#e07a00","favorite":"#ffa2a4"},"dark":false},"options":{"variations":false}}}
